module.exports = __webpack_public_path__ + "static/media/loc3_img33.a1b95859.jpg";